import axios from "axios";
import router from "@/router";
import { showCustom } from "@/assets/js/utils/alertService";

// Vue CLI 會自動在編譯時注入 process.env.NODE_ENV
// development = npm run serve
// production = npm run build
const apiClient = axios.create({
  //baseURL: "http://localhost:7225/api", // 後端 API 的根路徑
  baseURL: "https://api.annyoohoh.com.tw/api", // 後端 API 的根路徑
  // headers: {
  //   "Content-Type": "application/json",
  // },
  withCredentials: true, // 支援 Cookies（如果需要）
});

apiClient.interceptors.request.use(
  (config) => {
    // 只處理檔案上傳的 Content-Type
    if (config.url?.includes("/upload")) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

let isShowing401 = false;
let isRedirecting = false;

// 🔴 回應攔截器：統一處理 401 錯誤
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const currentPath = router.currentRoute.value.path;

    // ✅ 如果是 /reset 頁面的 API 呼叫，就直接拒絕錯誤，不進行 401 特別處理
    const config = error.config || {};
    const requestUrl = config.url || "";

    // ✅ 跳過特定頁面和 API 的 401 處理
    const skipAuth401Pages = ["/products", "/", "/video", "/contact"];
    const skipAuth401APIs = [
      "/reset-password",
      "/front/cart",
      "/front/customer/verify",
    ];

    const shouldSkip401 =
      skipAuth401Pages.includes(currentPath) ||
      skipAuth401APIs.some((api) => requestUrl.includes(api));

    // ✅ 如果在登入頁、已經在跳轉中、或是應該跳過的頁面/API，直接拒絕錯誤不做處理
    if (currentPath === "/login" || isRedirecting || shouldSkip401) {
      return Promise.reject(error);
    }

    // ✅ 401 未授權或 token 過期（只對需要驗證的頁面處理）
    if (status === 401 && !isShowing401) {
      isShowing401 = true;
      isRedirecting = true;

      try {
        await showCustom({
          icon: "warning",
          title: "登入逾時",
          text: "您的登入憑證已過期，請重新登入。",
        });

        document.cookie =
          "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        await router.push("/login");

        setTimeout(() => {
          isShowing401 = false;
          isRedirecting = false;
        }, 500);
      } catch (redirectError) {
        console.error("跳轉登入頁失敗:", redirectError);
        isShowing401 = false;
        isRedirecting = false;
      }
    }

    return Promise.reject(error);
  },
);

// 統一的 API 調用方法
export default {
  // GET 請求
  get(endpoint, params = {}) {
    return apiClient.get(endpoint, { params });
  },

  // POST 請求
  post(endpoint, data) {
    return apiClient.post(endpoint, data);
  },

  // PUT 請求
  put(endpoint, data) {
    return apiClient.put(endpoint, data);
  },

  // DELETE 請求
  // 原本 delete(endpoint) 無法傳遞 data，需改成以下 ⬇️
  delete(endpoint, data = {}) {
    return apiClient.delete(endpoint, { data }); // ✅ 傳 data 進 body
  },
};
